import { render } from "./login-callback.vue?vue&type=template&id=f06af852&scoped=true&ts=true"
import script from "./login-callback.vue?vue&type=script&lang=ts"
export * from "./login-callback.vue?vue&type=script&lang=ts"

import "./login-callback.scss?vue&type=style&index=0&id=f06af852&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f06af852"]])

export default __exports__